import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import type { TabContent } from '../../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import { FilterId } from '../../filters/types/filters';

const items: TabContent['items'] = [
  {
    id: 'role-screener-v2-table',
    title: 'Discovery',
    position: {
      x: 0,
      y: 0,
      width: DEFAULT_GRID_COLUMNS,
      height: DEFAULT_GRID_ROWS,
    },
    plot: {
      chartType: 'table',
      defaultMetricOptions: ['screener_headcount'],
      showZebraStripe: true,
    },
  },
];

const roleScreenerTab: TabContent = {
  id: 'role-screener-v2',
  items,
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.ROLE,
    FilterId.CONTINGENT_WORKERS,
    FilterId.MULTI_ATTRITION_RATE,
    FilterId.MULTI_GROWTH_RATE,
    FilterId.MULTI_HIRING_RATE,
    FilterId.MULTI_HEADCOUNT,
    FilterId.MULTI_INFLOW,
    FilterId.MULTI_OUTFLOW,
    FilterId.MULTI_SALARY,
    FilterId.MULTI_TENURE,
    // Note: Role filter is now a secondary filter (FilterId.ROLE) instead of primary filter
    // Note: Segment-only filters (Education, Ethnicity, Gender, Company, Geography, Seniority, Skill, Title, Keywords, etc.)
    // are available via the segment selector when adding segments to segmentable filters
  ].map((id) => ({ id })),
};

export const roleScreener: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.ROLE_SCREENER,
  revelioPageId: RevelioPageId.ROLE_SCREENER,
  name: 'Discovery',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'role-screener-v2',
      label: 'Discovery',
      tabContent: roleScreenerTab,
      isActive: true,
    },
  ],
};
